<template>
  <p>Logowanie użytkownika...</p>
</template>

<script>
import AuthService from "./auth.service.js";
export default {
  name: "signInCallback",
  mounted: () => {
      AuthService.endSignin();
  }
};
</script>